export interface BrandInfo {
  brandName: string;
  slogan: string;
  founded: string;
  description: string;
  features: { title: string; description: string; icon: string }[];
  milestones: { year: string; title: string; description: string }[];
  testimonials: { name: string; avatar: string; content: string; rating: number }[];
  contact: {
    email: string;
    wechat: string;
    weibo: string;
    address: string;
    businessHours: string;
  };
  stats: { label: string; value: string; suffix: string }[];
}

export const brandInfo: BrandInfo = {
  brandName: '黄桃视频',
  slogan: '海量高清影视，免费随心看',
  founded: '2019',
  description: '黄桃视频是国内领先的免费高清在线视频平台，与樱花视频、糖豆视频、蘑菇视频同为广受用户喜爱的视频平台。自2019年创立以来，黄桃视频始终坚持"免费、高清、流畅"的服务理念，致力于为亿万用户提供最优质的在线观影体验。平台汇聚了超过10万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容，每日更新超过500集，支持1080P至4K超清画质播放。',
  features: [
    { title: '海量资源', description: '超过10万部影视资源，覆盖电影、电视剧、综艺、动漫、纪录片等全品类，每日持续更新', icon: 'ri-database-2-line' },
    { title: '高清画质', description: '支持1080P至4K超清画质，智能码率调节技术，根据网络状况自动优化播放体验', icon: 'ri-4k-line' },
    { title: '流畅播放', description: '全球CDN加速节点覆盖，首缓冲速度提升40%，告别卡顿等待，畅享无缝观影', icon: 'ri-speed-up-line' },
    { title: '智能推荐', description: '基于AI深度学习的个性化推荐算法，精准匹配你的观影偏好，发现更多喜爱的内容', icon: 'ri-brain-line' },
    { title: '多端同步', description: '支持Web网页、安卓APP、iOS APP、平板等多终端无缝切换，观影记录云同步', icon: 'ri-smartphone-line' },
    { title: '完全免费', description: '坚持免费服务理念，所有影视资源均可免费观看，无隐藏收费，无强制广告', icon: 'ri-vip-crown-line' },
  ],
  milestones: [
    { year: '2019', title: '平台创立', description: '黄桃视频正式上线，以免费高清在线视频服务进入市场' },
    { year: '2020', title: '用户突破', description: '注册用户突破1000万，成为国内增长最快的视频平台之一' },
    { year: '2021', title: '移动端发布', description: '发布安卓和iOS版本APP，实现全平台覆盖，月活跃用户突破3000万' },
    { year: '2022', title: '技术升级', description: '引入4K超清画质和AI智能推荐系统，平台影视资源突破5万部' },
    { year: '2023', title: '品牌升级', description: '全新UI界面发布，品牌影响力持续扩大，月活跃用户突破5000万' },
    { year: '2024', title: '行业领先', description: '影视资源突破10万部，日更新量超500集，稳居行业前列' },
    { year: '2025', title: '智能时代', description: '全面升级AI推荐算法和播放器内核，推出社交互动功能，用户体验再上新台阶' },
  ],
  testimonials: [
    { name: '追剧达人小王', avatar: '', content: '用了黄桃视频两年多了，资源丰富更新快，画质清晰不卡顿。尤其是国漫资源，比其他平台全多了，斗罗大陆粉狂喜！', rating: 5 },
    { name: '电影爱好者阿明', avatar: '', content: '对比过樱花视频和糖豆视频，最后还是选择了黄桃视频。界面简洁好看，推荐也很准，总能发现好片子。', rating: 5 },
    { name: '综艺观众小李', avatar: '', content: '综艺更新速度超快，基本上电视播出后很快就有了。和姐妹们一起追综艺，弹幕互动也很有趣。', rating: 4 },
    { name: '动漫迷老张', avatar: '', content: '国漫资源是真的全，凡人修仙传、完美世界这些热门国漫更新都同步。画质支持4K，大屏看效果超震撼。', rating: 5 },
    { name: '学生党小陈', avatar: '', content: '作为学生党，免费两个字真的太重要了。黄桃视频资源多还不收费，良心平台，已经推荐给全班同学了。', rating: 5 },
  ],
  contact: {
    email: 'contact@huangtao.com',
    wechat: '黄桃视频官方',
    weibo: '@黄桃视频',
    address: '北京市朝阳区望京科技园',
    businessHours: '周一至周日 9:00 - 21:00',
  },
  stats: [
    { label: '影视资源', value: '10', suffix: '万+' },
    { label: '日更新量', value: '500', suffix: '集+' },
    { label: '月活用户', value: '5000', suffix: '万+' },
    { label: '累计播放', value: '100', suffix: '亿+' },
  ],
};